import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import {EventIntf} from "../ServerTypes";

function stringVal(json: any, key: string) {
    const v = json[key]
    if (v) {
        return v + ""
    } else {
        return ""
    }
}

export default function MainVenueConfig(prop: {event: EventIntf, setValueSaver:(saver:() => string | null) => void}) {
    const venueData = JSON.parse(prop.event.venueData)
    const [eventName, setEventName] = useState(stringVal(venueData, "eventName"))
    const [sessionizeId, setSessionizeId] = useState(stringVal(venueData, "sessionizeId"))
    const [room1Id, setRoom1Id] = useState(stringVal(venueData, "room1Id"))
    const [room2Id, setRoom2Id] = useState(stringVal(venueData, "room2Id"))
    const [room3Id, setRoom3Id] = useState(stringVal(venueData, "room3Id"))
    const [room4Id, setRoom4Id] = useState(stringVal(venueData, "room4Id"))

    prop.setValueSaver(() => {
        return JSON.stringify({
            ...venueData,
            eventName: eventName,
            sessionizeId: sessionizeId,
            room1Id: room1Id,
            room2Id: room2Id,
            room3Id: room3Id,
            room4Id: room4Id
        })
    })
    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Event Info
            </Typography>
            <Grid item xs={12}>
                <TextField
                    required
                    id="eventName"
                    name="eventName"
                    label="Event Name"
                    onChange={(event) => {
                        setEventName(event.target.value)
                    }}
                    value={eventName}
                    fullWidth
                />
            </Grid>
            <br/>
            <Typography variant="h6" gutterBottom>
                Sessionize Info
            </Typography>
            <Grid item xs={12}>
                <TextField
                    required
                    id="sessionizeId"
                    name="sessionizeId"
                    label="Sessionize Id"
                    onChange={(event) => {
                        setSessionizeId(event.target.value)
                    }}
                    value={sessionizeId}
                    fullWidth
                />
            </Grid>
            <br/>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="room1Id"
                        name="room1Id"
                        label="Room 1 Id"
                        onChange={(event) => {
                            setRoom1Id(event.target.value)
                        }}
                        value={room1Id}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="room2Id"
                        name="room2Id"
                        label="Room 2 Id"
                        onChange={(event) => {
                            setRoom2Id(event.target.value)
                        }}
                        value={room2Id}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="room3Id"
                        name="room3Id"
                        label="Room 3 Id"
                        onChange={(event) => {
                            setRoom3Id(event.target.value)
                        }}
                        value={room3Id}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        id="room4Id"
                        name="room4Id"
                        label="Room 4 Id"
                        onChange={(event) => {
                            setRoom4Id(event.target.value)
                        }}
                        value={room4Id}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
